import { render, staticRenderFns } from "./createOrg.vue?vue&type=template&id=69eb65ea&"
import script from "./createOrg.vue?vue&type=script&lang=js&"
export * from "./createOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports